<div class="paginador" *ngIf="totalPaginas">

  <div class="btn-group btn-group-sm paginador-botones">
    <button type="button" class="btn btn-outline-primary"
            title="{{t.primera}}" [attr.aria-label]="t.primera"
            [disabled]="!hayAnterior" (click)="onPrimera()">
      <i class="bi bi-chevron-double-left paginador-icono"></i><span class="paginador-texto">{{t.primera}}</span>
    </button>
    <button type="button" class="btn btn-outline-primary"
            title="{{t.anterior}}" [attr.aria-label]="t.anterior"
            [disabled]="!hayAnterior" (click)="onAnterior()">
      <i class="bi bi-chevron-left paginador-icono"></i><span class="paginador-texto">{{t.anterior}}</span>
    </button>
    <button type="button" class="btn btn-outline-primary"
            title="{{t.siguiente}}" [attr.aria-label]="t.siguiente"
            [disabled]="!haySiguiente" (click)="onSiguiente()">
      <i class="bi bi-chevron-right paginador-icono"></i><span class="paginador-texto">{{t.siguiente}}</span>
    </button>
    <button type="button" class="btn btn-outline-primary"
            title="{{t.ultima}}" [attr.aria-label]="t.ultima"
            [disabled]="!haySiguiente" (click)="onUltima()">
      <i class="bi bi-chevron-double-right paginador-icono"></i><span class="paginador-texto">{{t.ultima}}</span>
    </button>
  </div>

  <span class="paginador-estado">
    {{t.pagina}} {{pagina}} / {{totalPaginas}}
    <span class="paginador-total">{{totalRegistros}} {{t.registros}}</span>
  </span>

  <div class="paginador-tamano">
    <label class="paginador-estado mb-0 mr-1">{{t.mostrar}}</label>
    <select class="form-control form-control-sm paginador-select"
            [ngModel]="registrosPorPagina"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onCambiarRegistros($event)">
      <option *ngFor="let opcion of opcionesRegistros" [ngValue]="opcion">{{opcion}}</option>
    </select>
  </div>

</div>
